export default __webpack_public_path__ + "static/media/78.9269854d.png";